/**
 * Strict-equality helpers for null/undefined checks. Use these instead of `== null` or `!= null`
 * so we stay within the `eqeqeq` rule while still treating `null` and `undefined` the same.
 */

/** True when `value` is `null` or `undefined`. */
export const isNullish = (value: unknown): value is null | undefined =>
  value === null || value === undefined;

/** True when `value` is neither `null` nor `undefined`. */
export const isNonNullish = <T>(value: T | null | undefined): value is T =>
  value !== null && value !== undefined;

/**
 * True when `value` is a non-null, non-undefined, non-empty identifier.
 * Accepts numbers and strings; the empty string is treated as "missing".
 */
export const isNonEmptyId = (value: unknown): value is string | number =>
  isNonNullish(value) && value !== '';
